define('responsive-gameday/views/Monitor/ViewModels/distributors/PitchByPitchViewDistributor',['require','exports','module','jquery','message-service/message-service','../../Events/SceneStateEvents','../../Events/ViewModelUpdateEvents','GameDayCore/GDModel/enums/datasources/Datasources','GameDayCore/GDUtil/dataMapping/NumberWithOrdinal','extant/extant'],function(require,exports,module) {

    var $ = require("jquery"),
        MessageService = require("message-service/message-service"),
        SceneStateEvents = require("../../Events/SceneStateEvents"),
        UpdateEvents = require("../../Events/ViewModelUpdateEvents"),
        Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources"),
        NumberWithOrdinal = require("GameDayCore/GDUtil/dataMapping/NumberWithOrdinal"),
        exists = require("extant/extant");

    var gameData,
        stateUpdates,
        dataPack;

    exports.setGameData = function(game, scenes) {
        gameData = $.extend({}, game);
        stateUpdates = scenes;

        buildSendDataPack();
        MessageService.off(UpdateEvents.REQUEST_PITCHBYPITCH_DATA, exports.handleUpdateRequest);
        MessageService.on.call(exports,UpdateEvents.REQUEST_PITCHBYPITCH_DATA, exports.handleUpdateRequest);
        MessageService.publish(UpdateEvents.UPDATE_PITCHBYPITCH, dataPack);
    };

    exports.handleUpdateRequest = function() {
        gameData = GDC.getGameData();
        buildSendDataPack();
        MessageService.publish(UpdateEvents.UPDATE_PITCHBYPITCH, dataPack);
    };

    function buildSendDataPack() {
        dataPack = { };
        var inningState = gameData.play.half_inning,
            events = [];
        /*
         * Grab innings data depending on what half inning we're in
         */
        var inningState = gameData.play.half_inning;
        if(inningState === 'top') {
            events = events.concat(gameData.inning.top);
        } else if (inningState === 'bottom') {
            events = events.concat(gameData.inning.bottom);
        }

        dataPack.inningPlays = dataPack.events=events.reverse();
        // Be grammatically correct when listing how many outs there are.
        dataPack.events.outsText = function() {
            switch(this.o) {
                case 0:
                case 2:
                case 3:
                    return "outs";
                case 1:
                    return "out";
            }
        };

        dataPack.game = gameData.game;

        if (exists(gameData, "play.atbat")) {
            dataPack.atbat = gameData.play.atbat;
            dataPack.pitches = dataPack.atbat.pitches;
            
            // // If the play is complete, don't show the event from the innings file yet..
            // if(dataPack.events.length && dataPack.events[0].num===dataPack.atbat.num) {
            //     dataPack.events.shift();
            // }
        }
    }
});
